// Fix Supabase password recovery hash → set-password route with query params
if (
  window.location.hash &&
  window.location.hash.includes("access_token") &&
  window.location.hash.includes("type=recovery")
) {
  const hash = window.location.hash.substring(1);
  const newUrl = `${window.location.origin}/#/set-password?${hash}`;
  window.location.replace(newUrl);
}
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";

// After a new deploy, the service worker may replace its pre-cache while
// the page still holds old chunk references. A reload picks up the new
// HTML + new SW cache. A sessionStorage guard prevents infinite loops.
// See https://vite.dev/guide/build.html#load-error-handling
window.addEventListener("vite:preloadError", () => {
  const key = "chunk-reload";
  if (!sessionStorage.getItem(key)) {
    sessionStorage.setItem(key, "1");
    window.location.reload();
  }
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
